(function () {
  if (window.etMainProductLoaded) return;
  window.etMainProductLoaded = true;

  function initSwatches(root) {
    root.querySelectorAll('[data-et-swatches]').forEach(function (swatches) {
      if (swatches.dataset.etInit) return;
      swatches.dataset.etInit = 'true';

      var value = swatches.querySelector('[data-et-swatches-value]');
      if (!value) return;

      var activeName = value.textContent;
      var reset = function () {
        value.textContent = activeName;
      };

      swatches.querySelectorAll('[data-et-swatch-name]').forEach(function (swatch) {
        var show = function () {
          value.textContent = swatch.dataset.etSwatchName;
        };
        swatch.addEventListener('mouseenter', show);
        swatch.addEventListener('focus', show);
        swatch.addEventListener('click', show);
      });

      swatches.addEventListener('mouseleave', reset);
      swatches.addEventListener('focusout', function (event) {
        if (!swatches.contains(event.relatedTarget)) reset();
      });
    });
  }

  function initUpsells(root) {
    root.querySelectorAll('[data-et-upsell]').forEach(function (upsell) {
      if (upsell.dataset.etInit) return;
      upsell.dataset.etInit = 'true';

      var select = upsell.querySelector('[data-et-upsell-variant]');
      if (!select) return;

      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var price = upsell.querySelector('[data-et-upsell-price]');
        var badge = upsell.querySelector('[data-et-upsell-badge]');

        if (price) price.textContent = option.dataset.price;
        if (badge) {
          badge.textContent = option.dataset.badge;
          badge.hidden = !option.dataset.badge;
        }
      });
    });
  }

  /* Upsell variant to add with the main product, or null when the toggle is off. */
  function getUpsellVariantId(formId) {
    var sectionId = formId.replace('product-form-', '');
    var upsell = document.querySelector(
      '[data-et-upsell][data-section-id="' + CSS.escape(sectionId) + '"]'
    );
    if (!upsell) return null;

    var toggle = upsell.querySelector('[data-et-upsell-toggle]');
    if (!toggle || !toggle.checked) return null;

    var select = upsell.querySelector('[data-et-upsell-variant]');
    return (select ? select.value : toggle.value) || null;
  }

  function addUpsellToCart(variantId, sections) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (sections) {
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  /*
   * Runs before the theme's product-selector submit handler (capture phase).
   * When the upsell is toggled on it takes over the add: main product first via the
   * theme's addToCart(), then the upsell, then the drawer renders with both lines.
   * If the upsell add fails, the drawer still renders the main product.
   */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      // Not form.id: the product form has an input named "id", which shadows the property.
      var formId = form.getAttribute('id') || '';
      if (formId.indexOf('product-form-') !== 0) return;
      if (typeof addToCart !== 'function') return;

      var upsellVariantId = getUpsellVariantId(formId);
      if (!upsellVariantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var selector = document.querySelector(
        'product-selector[data-form-id="#' + CSS.escape(formId) + '"]'
      );
      if (selector && typeof selector.areCustomFieldsValid === 'function' && !selector.areCustomFieldsValid()) {
        return;
      }

      var cartDrawer = document.querySelector('cart-drawer');
      var useDrawer = !!cartDrawer && window.location.pathname !== routes.cart_url;
      var sections = useDrawer
        ? cartDrawer.getSectionsToRender().map(function (section) {
            return section.section;
          })
        : null;
      var submitButton = form.elements.add;
      var showError = function (message) {
        if (selector && typeof selector.handleErrorMessage === 'function') {
          selector.handleErrorMessage(message);
        }
      };

      if (submitButton) submitButton.classList.add('disabled');

      addToCart(form, sections)
        .then(function (response) {
          if (response.status) {
            showError(response.description);
            return;
          }
          showError();

          return addUpsellToCart(upsellVariantId, sections).then(function (upsellResponse) {
            if (!useDrawer) {
              window.location.href = routes.cart_url;
              return;
            }
            var added = upsellResponse && !upsellResponse.status;
            cartDrawer.renderContents(added ? upsellResponse : response);
          });
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          if (submitButton) submitButton.classList.remove('disabled');
        });
    },
    true
  );

  function init(root) {
    initSwatches(root);
    initUpsells(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
